import {
  DesktopDatePicker,
  DesktopDatePickerProps,
  PickerValidDate,
} from '@mui/x-date-pickers';
import React, { FC, useState } from 'react';

import translate from '../../../i18n/translate';
import MaterialSymbolCalendarIcon from '../MuiIcon/MaterialSymbolIcon/Calendar';

type Props = DesktopDatePickerProps<PickerValidDate> & {
  isReadOnly?: boolean;
  requestClear?: () => void;
};

/**
 * Common date picker component
 *
 * @param props              Props passed to the component
 * @param props.isReadOnly   Whether the input should be readonly
 * @param props.requestClear Request that the date is cleared
 * @returns                  The component itself
 */
const PickerDate: FC<Props> = ({
  isReadOnly = false,
  requestClear,
  ...props
}) => {
  const [open, setOpen] = useState(false);

  return (
    // Force DesktopDatePicker to ensure consistent UI (e.g. clear button, icons) across devices
    <DesktopDatePicker
      label={translate('DUE_DATE__LABEL_DATE')}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      slotProps={{
        field: {
          clearable: true,
          onClear: requestClear,
          /**
           * Do nothing on keyboard input if picker is read-only
           *
           * @param event Event that took place
           */
          onKeyDown: isReadOnly
            ? event => {
                event.preventDefault();
              }
            : undefined,
        },
        textField: {
          InputLabelProps: {
            shrink: true,
          },
          /**
           * Open the date picker when the input is clicked
           */
          onClick: () => {
            setOpen(true);
          },
          slotProps: {
            htmlInput: {
              readOnly: isReadOnly,
            },
          },
        },
      }}
      slots={{
        openPickerIcon: MaterialSymbolCalendarIcon,
      }}
      {...props}
    />
  );
};

export default PickerDate;
